import { Theme } from "@amx/ux-twoui-theming";
import { Alignment, IStackItemStyles, IStackProps } from "@fluentui/react";
import { ChoiceGroupHeight, MediaPosition } from "../../shared/props";
import { getChoiceGroupButtonStyles } from "../../shared/styles";

export const mediaSize = "xl";

export const getMediaButtonLineItemsHorizontalAlign = (mediaPosition: MediaPosition): Alignment => {
    switch (mediaPosition) {
        case "left":
        case "right":
            return "start";
        case "top":
        case "bottom":
            return "center";
    }
};

//Styling for container that holds the media component
export const getMediaContainerStyles = (mediaPosition: MediaPosition): IStackItemStyles => {
    const isTopOrBottom = mediaPosition === "top" || mediaPosition === "bottom";

    return {
        root: {
            width: isTopOrBottom ? "100%" : "100px",
            overflow: "hidden",
            display: "flex",
            paddingTop: mediaPosition === "bottom" ? "8px" : undefined,
            paddingBottom: mediaPosition === "top" ? "8px" : undefined,
            justifyContent: "center",
            alignItems: "center",
            paddingRight: mediaPosition === "left" ? "24px" : undefined,
        }
    };
};

/** The styling for the media button component */
export const getMediaButtonRootStackProps = (
    theme: Theme,
    isMobile: boolean,
    height: ChoiceGroupHeight = "auto",
    mediaPosition: MediaPosition,
    disabled?: boolean,
    selected?: boolean
): IStackProps => {
    const isLeftOrRight = ["left", "right"].includes(mediaPosition);
    const isBottomOrRight = ["bottom", "right"].includes(mediaPosition);
    const isTopOrBottom = ["top", "bottom"].includes(mediaPosition);

    const horizontalAlign = mediaPosition === "right" ? "space-between" :
        isTopOrBottom ? "center" : undefined;
    const verticalAlign = isTopOrBottom ? "center" : "start";

    //textAlignment will be 'left' when mediaPosition is 'left' or 'right' and will be 'center' when
    //mediaPosition is 'top' or 'bottom'
    const textAlignment = isLeftOrRight ? "left" : "center";

    return {
        horizontal: isLeftOrRight,
        reversed: isBottomOrRight,
        verticalAlign,
        horizontalAlign,
        styles: {
            root: {
                ...getChoiceGroupButtonStyles(theme, isMobile, height, textAlignment, disabled, selected)
            }
        }
    };
};
